'use client';
import noop from 'lodash/noop';
import React, { createContext } from 'react';

export const BreadcrumbContext = createContext({
  setDarkBackground: noop,
  darkBackground: false,
});

interface Props {
  children: React.ReactNode;
}

const BreadCrumbProvider = ({ children }: Props) => {
  const [darkBackground, setDarkBackground] = React.useState(false);

  return (
    <BreadcrumbContext.Provider
      value={{
        setDarkBackground,
        darkBackground,
      }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => React.useContext(BreadcrumbContext);

export default BreadCrumbProvider;
